export const SupportPage = () => {
  return (
    <>
      <div>応援</div>
    </>
  )
}
